import { useAuthStore } from '~/store/auth.store';
import { TENANT_ADMIN_ROLES } from '~/utils/guards';

/**
 * Check if the current user has a tenant-admin role (one of `TENANT_ADMIN_ROLES`).
 * Super admins always return true.
 */
export function useTenantAdmin(): boolean {
  const user = useAuthStore((state) => state.user);
  if (!user) return false;
  if (user.isSuperAdmin) return true;
  const upperRole = user.roleCode.toUpperCase();
  return TENANT_ADMIN_ROLES.includes(upperRole as (typeof TENANT_ADMIN_ROLES)[number]);
}
